import "./E404.css";
const E404 = () => {
  return (
    <div className="err-wrapper">
      <h1 className="err-title">This Page is under development</h1>
      <a href="/" className="home">
        Home
      </a>
    </div>
  );
};

export default E404;
